import { HttpLink } from '@apollo/client';

import { envSwitch } from '@/utils/environmentUtils';

const uri = envSwitch({
  development: 'http://localhost:8000/graphql/',
  dev: 'https://cortex.bighealthdev.com/dev/graphql/',
  testing: 'https://cortex-testing.limbix.com/graphql/',
  stage: 'https://cortex.bighealthstage.com/stage/graphql/',
  stable: 'https://cortex-stable.limbix.com/graphql/',
  prod: 'https://cortex.bighealth.com/prod/graphql/',
  pr: 'https://cortex.bighealthdev.com/dev/graphql/',
});

export const httpLink = new HttpLink({
  uri,
  credentials: 'same-origin',
});
